// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"d0848315","197":"4c462bdc","220":"f033ada9","723":"ee92f3cf","789":"3fee82c0","835":"a489f263","865":"6efc2318"}[chunkId] + ".chunk.js";
};